import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../../environments/environment";
import { CustomTreatment } from "./custom-treatment.model";
import { HttpClient, HttpParams } from "@angular/common/http";

const API_ENDPOINT = environment.API_ENDPOINT + "/custom-treatments";

@Injectable()
export class CustomTreatmentService {
  customTreatments: Observable<Array<CustomTreatment>>;

  constructor(private http: HttpClient) {}

  getCustomTreatments(
    showDeleted: boolean = false,
  ): Observable<CustomTreatment[]> {
    const params = new HttpParams().append(
      "includeDeleted",
      showDeleted.toString(),
    );

    return this.http.get<CustomTreatment[]>(API_ENDPOINT, { params });
  }

  getCustomTreatment(
    customTreatment: CustomTreatment,
  ): Observable<CustomTreatment> {
    return this.http.get<CustomTreatment>(
      API_ENDPOINT + "/" + customTreatment.id,
    );
  }

  createCustomTreatment(
    customTreatment: CustomTreatment,
  ): Observable<CustomTreatment> {
    return this.http.post<CustomTreatment>(API_ENDPOINT, customTreatment);
  }

  updateCustomTreatment(
    customTreatment: CustomTreatment,
  ): Observable<CustomTreatment> {
    return this.http.put<CustomTreatment>(
      API_ENDPOINT + "/" + customTreatment.id,
      customTreatment,
    );
  }

  deleteCustomTreatment(
    customTreatment: CustomTreatment,
  ): Observable<CustomTreatment> {
    return this.http.delete<CustomTreatment>(
      API_ENDPOINT + "/" + customTreatment.id,
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/custom-treatment/custom-treatment.service.ts